import { html, css, LitElement } from 'lit'
import { refreshIcon } from '../assets/icons.js'
import { toast } from '../../src/utilities/toast.js'

export class RefreshButton extends LitElement {
  static properties = {
    spinning: { type: Boolean },
    showText: { type: Boolean },
  }

  constructor() {
    super()
    this.spinning = false
    this.showText = false
  }

  handleClick() {
    this.spinning = true
    window.dispatchEvent(new CustomEvent('refresh'))
    toast('Refreshing...')
    setTimeout(() => {
      this.spinning = false
    }, 1000)
  }

  render() {
    return html`
      <div @click=${this.handleClick} class="refresh-button-container">
        <button class="refresh-button ${this.spinning ? 'spinning' : ''}">
          ${refreshIcon}
        </button>
        ${this.showText ? html`<p>Refresh</p>` : ''}
      </div>
    `
  }
  static styles = css`
    .refresh-button-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: left;
      gap: 8px;
      cursor: pointer;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      border: none;
      cursor: pointer;
      width: 32px;
      height: 32px;
    }

    p {
      margin: 0;
    }

    button svg {
      fill: var(--kula-grey-1);
      transition: fill 0.3s ease;
      width: 24px;
      height: 24px;
    }

    .spinning svg {
      animation: spin 1s linear;
      fill: var(--kula-green);
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `
}

customElements.define('refresh-button', RefreshButton)
export default RefreshButton
